import { Navigate, NavLink, RouteObject, useNavigate } from "react-router";

import { Button, ButtonStyle, checkTabIsActive, PageHeading, Tabs } from "@prequel/shared-components";

import MagicLinkForm from "./MagicLinkForm";
import MagicLinksTable from "./MagicLinksTable";

import Breadcrumbs from "@/components/Breadcrumbs";

const tabs = [
  <NavLink key="Active" to="/magic-links/active" className={checkTabIsActive} end>
    Active
  </NavLink>,
];

const MagicLinksListLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Magic Links">
          <Button text="Generate Link" onClick={() => navigate("/magic-links/new")} type={ButtonStyle.SECONDARY} />
        </PageHeading>
        <Tabs tabs={tabs} />
        <MagicLinksTable />
      </div>
    </div>
  );
};

const MagicLinkFormLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-xl px-7 py-4">
        <PageHeading
          title="Generate Link"
          onGoBack={() => navigate("/magic-links/active")}
          breadcrumbs={<Breadcrumbs />}
        />
        <MagicLinkForm />
      </div>
    </div>
  );
};

export const magicLinksRoutes: RouteObject = {
  path: "magic-links",
  handle: {
    breadcrumb: () => ({ label: "Magic Links" }),
  },
  children: [
    {
      path: "active",
      element: <MagicLinksListLayout />,
    },
    {
      path: "new",
      handle: {
        breadcrumb: () => ({ label: "Generate Link" }),
      },
      element: <MagicLinkFormLayout />,
    },
    {
      path: "*",
      element: <Navigate to="/magic-links/active" replace />,
    },
  ],
};
